<script lang="ts">
  import { swUpdateAvailable } from '$lib/stores/service-worker-store';
  import { applyUpdate } from '../register-service-worker';
  import { onMount } from 'svelte';

  // Use local storage to persist dismissal state
  const STORAGE_KEY = 'update_notification_dismissed';
  const DISMISSAL_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  let showUpdateBanner = true;

  onMount(() => {
    // Check if there's a stored dismissal timestamp
    const dismissedAt = localStorage.getItem(STORAGE_KEY);

    if (dismissedAt) {
      const dismissedTime = parseInt(dismissedAt, 10);
      const now = Date.now();

      // If dismissal was less than expiry time ago, keep it hidden
      if (now - dismissedTime < DISMISSAL_EXPIRY) {
        showUpdateBanner = false;
      } else {
        // Clear expired dismissal
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  });

  function dismissNotification() {
    showUpdateBanner = false;
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  }
</script>

{#if $swUpdateAvailable && showUpdateBanner}
  <div class="fixed bottom-8 left-1/2 z-[9998] -translate-x-1/2">
    <div
      class="bg-gray-dark-3 border-gray-dark-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 rounded-md border px-4 py-2.5 shadow-lg backdrop-blur-md"
    >
      <span class="font-architekt whitespace-nowrap text-sm font-medium text-white"
        >New app version available</span
      >
      <div class="flex items-center gap-2">
        <button
          class="text-gray-dark-1 rounded-md bg-white px-3 py-1.5 text-xs font-medium transition-colors hover:bg-opacity-90"
          on:click={applyUpdate}
        >
          Refresh
        </button>
        <button
          class="bg-gray-dark-6 rounded-md px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-white/10"
          on:click={dismissNotification}
        >
          Later
        </button>
      </div>
    </div>
  </div>
{/if}
